import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Products from "../pages/products/page";
import Contact from "../pages/contact/page";
import WellnessBlog from "../pages/wellness-blog/page";
import Ecommerce from "../pages/ecommerce/page";
import Profile from "../pages/profile/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Finance from "../pages/dashboard/finance/page";
import Documents from "../pages/dashboard/documents/page";
import Tasks from "../pages/dashboard/tasks/page";
import FarmingActivities from "../pages/dashboard/farming/page";
import Policies from "../pages/dashboard/policies/page";
import Discussions from "../pages/dashboard/discussions/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/ecom",
    element: <Ecommerce />,
  },
  {
    path: "/wellness-blog",
    element: <WellnessBlog />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/dashboard/finance",
    element: <Finance />,
  },
  {
    path: "/dashboard/documents",
    element: <Documents />,
  },
  {
    path: "/dashboard/tasks",
    element: <Tasks />,
  },
  {
    path: "/dashboard/farming",
    element: <FarmingActivities />,
  },
  {
    path: "/dashboard/policies",
    element: <Policies />,
  },
  {
    path: "/dashboard/discussions",
    element: <Discussions />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
